import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getLocalizedFacilityStringContent } from '../../../redux/modules/localization/localization-middleware';
import { DedicatedWorkflowPanel } from '../../../components/SystemShared/DedicatedWorkflowPanel';
import { messages } from '../../../containers/InviteAuthRep/InviteAuthRep.i18n';
import InviteAuthStatementForm from '../../../containers/InviteAuthRep/InviteAuthStatementForm';
import { setIsDedicatedWorkflow } from '../../../redux/modules/workflow/workflow-action-creator';
import { withAuth } from '../../../containers/Authenticated';


class InviteAuthStatementPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      signUpLegalStatement: '',
    };
  }

  componentDidMount = () => {
    const callback = (response) => {
      this.setState({ signUpLegalStatement: response.data });
    };

    getLocalizedFacilityStringContent(this.props.facilityId, this.props.languageCode, 'signuplegalstatement', callback);
    this.props.dispatch(setIsDedicatedWorkflow(true));
  }

  render() {
    if (this.state.signUpLegalStatement.length > 0) {
      return (
      <DedicatedWorkflowPanel headerTitle={messages.page.title} instruction={messages.page.instruction}>
        <InviteAuthStatementForm signUpLegalStatement={this.state.signUpLegalStatement} />
      </DedicatedWorkflowPanel>);
    }
    return null;
  }
}

InviteAuthStatementPage.propTypes = {
  dispatch: PropTypes.func,
  facilityId: PropTypes.string,
  languageCode: PropTypes.string,
};

const mapStateToProps = (state) => ({
  facilityId: state.facility.facilityId,
  languageCode: state.language.languageCode,
});

const InviteAuthStatementPageWithAuth = withAuth(InviteAuthStatementPage);
export default connect(mapStateToProps)(withRouter(InviteAuthStatementPageWithAuth));